import { __extends } from "tslib";
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { SIDE_PADDING } from '../constants/handoffScrollableArea';
import * as screenLocation from '../constants/screenLocation';
import HotspotLayer from '../containers/HotspotLayer';
import styles from './ScreenImage.module.css';
var ScreenImage = /** @class */ (function (_super) {
    __extends(ScreenImage, _super);
    function ScreenImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScreenImage.prototype.componentDidMount = function () {
        this.resetGifAnimation();
    };
    ScreenImage.prototype.componentDidUpdate = function () {
        this.resetGifAnimation();
    };
    ScreenImage.prototype.resetGifAnimation = function () {
        if (this.props.resetGIF) {
            var img = this.img;
            img.src = img.src;
            // Note for reasons unknown we need setTimeout here (so the
            // state is changed in the next React update cycle. Or something)
            setTimeout(this.props.gifResetDone, 0);
        }
    };
    ScreenImage.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, hotspots = _b.hotspots, annotations = _b.annotations, elements = _b.elements, getScreenScrollPos = _b.getScreenScrollPos, imageMargin = _b.imageMargin, imageWidth = _b.imageWidth, imageHeight = _b.imageHeight, src = _b.src, screenID = _b.screenID, isCentredWebPrototype = _b.isCentredWebPrototype, isInHandoffMode = _b.isInHandoffMode, backgroundColor = _b.backgroundColor;
        var stretchedImageWidth = Math.ceil(imageWidth);
        var stretchedImageHeight = Math.ceil(imageHeight);
        var outerStyle = {
            marginLeft: imageMargin.marginLeft,
        };
        if (isCentredWebPrototype) {
            outerStyle.overflowX = 'hidden';
        }
        else {
            outerStyle.width = imageWidth;
        }
        var imgWrapperStyle = cx(styles.imgWrapper, (_a = {},
            _a[styles.handoffMode] = isInHandoffMode,
            _a));
        var appliedOuterStyle = getHandoffImageOuterStyle(isInHandoffMode, outerStyle, imageWidth);
        return (React.createElement("div", { style: appliedOuterStyle },
            React.createElement("div", { className: imgWrapperStyle },
                React.createElement("div", { className: "overflow-hidden", id: "screenImage", style: {
                        width: isCentredWebPrototype ? stretchedImageWidth : 'auto',
                        height: stretchedImageHeight + imageMargin.marginBottom,
                        marginTop: imageMargin.marginTop,
                        marginBottom: -imageMargin.marginBottom,
                        backgroundColor: isInHandoffMode && 'white',
                    } },
                    React.createElement("img", { alt: "", className: styles.img, ref: function (node) {
                            _this.img = node;
                        }, src: src, style: {
                            width: stretchedImageWidth,
                            height: stretchedImageHeight,
                            backgroundColor: "#".concat(backgroundColor),
                        } })),
                React.createElement("div", { className: styles.hotspotLayerWrapper },
                    React.createElement(HotspotLayer, { annotations: annotations, elements: elements, getScreenScrollPos: getScreenScrollPos, height: imageHeight, hotspots: hotspots, location: screenLocation.BODY, screenID: screenID })))));
    };
    return ScreenImage;
}(Component));
export default ScreenImage;
function getHandoffImageOuterStyle(isInHandoffMode, outerStyle, imageWidth) {
    if (isInHandoffMode) {
        var marginLeft = outerStyle.marginLeft;
        var marginBottom = SIDE_PADDING;
        if (marginLeft < SIDE_PADDING) {
            var newWidth = imageWidth + SIDE_PADDING * 2;
            var padding = "0 ".concat(SIDE_PADDING, "px");
            return { width: newWidth, padding: padding, marginBottom: marginBottom };
        }
        return { width: imageWidth, marginLeft: marginLeft, marginBottom: marginBottom };
    }
    return outerStyle;
}
ScreenImage.propTypes = {
    imageMargin: PropTypes.shape({
        marginTop: PropTypes.number.isRequired,
        marginBottom: PropTypes.number.isRequired,
    }),
    imageWidth: PropTypes.number.isRequired,
    imageHeight: PropTypes.number.isRequired,
    src: PropTypes.string.isRequired,
    hotspots: PropTypes.array,
    getScreenScrollPos: PropTypes.func,
    annotations: PropTypes.arrayOf(PropTypes.shape({
        left: PropTypes.number,
        top: PropTypes.number,
    })),
    elements: PropTypes.array,
    resetGIF: PropTypes.bool,
    gifResetDone: PropTypes.func.isRequired,
    isCentredWebPrototype: PropTypes.bool.isRequired,
    isInHandoffMode: PropTypes.bool,
    screenID: PropTypes.number.isRequired,
    backgroundColor: PropTypes.string.isRequired,
};
